export function getMeterTypeName(type) {
  switch (Number(type)) {
    case 1: return 'AC Energy';
    case 2: return 'DC Energy';
    case 3: return 'AC & DC Energy';
    default: return 'Unknown';
  }
}

export function getAssignmentStatus(fromDate, toDate) {
  const now = new Date();
  const from = fromDate ? new Date(fromDate) : null;
  const to   = toDate ? new Date(toDate) : null;
  if (from && from > now) return 'Pending';
  if (to && to < now) return 'Historical';
  return 'Active';
}

export function formatDate(value, locale) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString(locale);
  } catch {
    return '—';
  }
}

export function safeTrim(value) {
  return typeof value === 'string' ? value.trim() : value;
}

export function fmtDateGB(value) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('en-GB');
  } catch {
    return '—';
  }
}

export function toYesNo(value) {
  return value == null ? '—' : value ? 'Yes' : 'No';
}
